/* eslint-disable import/no-cycle */
import * as API from './api';

export * from './@types';

const UserModel = { ...API };

export default UserModel;
